import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageSwitch } from '@/hooks/useLanguage';

export default function AuthenticitySection() {
  const { t } = useTranslation();
  const { currentLang } = useLanguageSwitch();
  const prefix = currentLang === 'ko' ? '/ko' : currentLang === 'bn' ? '/bn' : '';

  return (
    <section className="w-full bg-white py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden bg-[#2D6A4F]/5 border border-[#2D6A4F]/10 p-8 md:p-12 lg:p-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            {/* Left: Icon + badge */}
            <div className="flex flex-col gap-6">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-full bg-[#2D6A4F]/10 flex items-center justify-center">
                  <i className="ri-qr-scan-line text-[#2D6A4F] text-2xl"></i>
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-[10px] tracking-[0.15em] uppercase text-[#2D6A4F] font-medium">
                    {t('home.authenticity.label')}
                  </span>
                  <span className="text-xs text-[#8A8A8A] font-light">
                    {t('home.authenticity.subLabel')}
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-3">
                <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2A2A2A] leading-[1.15]">
                  {t('home.authenticity.heading')}
                </h2>
                <p className="text-sm text-[#8A8A8A] font-light leading-[1.8] max-w-md">
                  {t('home.authenticity.body')}
                </p>
              </div>

              <Link
                to={prefix + '/verify'}
                className="mt-2 flex items-center justify-center gap-2 px-7 py-3.5 bg-[#2D6A4F] text-white text-xs tracking-[0.15em] uppercase rounded-full hover:bg-[#1E4D3A] transition-colors cursor-pointer w-full sm:w-fit text-center"
              >
                <i className="ri-shield-check-line"></i>
                {t('home.authenticity.cta')}
              </Link>
            </div>

            {/* Right: QR illustration */}
            <div className="flex items-center justify-center">
              <div className="relative">
                <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-white border-2 border-[#2D6A4F]/20 flex items-center justify-center">
                  <div className="flex flex-col items-center gap-3">
                    <i className="ri-qr-code-line text-5xl text-[#2D6A4F]/30"></i>
                    <span className="text-[10px] tracking-[0.1em] uppercase text-[#8A8A8A] font-light">
                      {t('home.authenticity.badge')}
                    </span>
                  </div>
                </div>
                {/* Decorative elements */}
                <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-[#2D6A4F]/10 flex items-center justify-center">
                  <i className="ri-check-line text-[#2D6A4F] text-sm"></i>
                </div>
                <div className="absolute -bottom-3 -left-3 w-8 h-8 rounded-full bg-[#2D6A4F]/10 flex items-center justify-center">
                  <i className="ri-shield-check-line text-[#2D6A4F] text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}